import { ILoginParams, ILoginResponse } from '@webtrader/core/api/user/login';
import request from '@webtrader/core/request';
import { checkIsNative } from '@webtrader/core/validators/device';

export interface IMT4LoginParams extends Omit<ILoginParams, 'userId'> {
  userId: number;
}

interface IMT4LoginResponse extends ILoginResponse {}

export default {
  demoLogin: (params: IMT4LoginParams) => {
    return checkIsNative()
      ? request.post<IMT4LoginResponse>('/api/auth/v2/metatrader4/demo/mobile/login', params)
      : request.post<IMT4LoginResponse>('/api/auth/v2/metatrader4/demo/login', params);
  },
  liveLogin: (params: IMT4LoginParams) => {
    return checkIsNative()
      ? request.post<IMT4LoginResponse>('/api/auth/v2/metatrader4/live/mobile/login', params)
      : request.post<IMT4LoginResponse>('/api/auth/v2/metatrader4/live/login', params);
  }
};
